import ClientWebservice from './ClientWebService';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class DestinationService extends ClientWebservice{

	constructor(client) {
		super('/destinations');
		this.token = Buffer.from(`${client.login}:${client.key}`, 'utf8').toString('base64');
	}

    getCityByCode(code, lang){
        return axios.get(`${this.url}/cities/${code}?languageCode=${lang}`,{
					headers: {
						'Accept': '*/*',
						'Access-Control-Allow-Origin' : '*',
						'Authorization': `Basic ${this.token}`
					}
				});
		};
		getCountries(){
			return axios.get(`${this.url}/countries`,{
				headers: {
					'Accept': '*/*',
					'Access-Control-Allow-Origin' : '*',
					'Authorization': `Basic ${this.token}`
				}
			});
		};
}



// WEBPACK FOOTER //
// ./src/services/DestinationService.js